import React from 'react'
import PageLayout from '../components/templates/page-layout/page-layout'
import CurVGameContent from '../components/organisms/curvGameContent/curvGameContent'

const GameTest = () => {
  return (
    <PageLayout hiddenNav={true}>
      <CurVGameContent />
    </PageLayout>
  )
}

export default GameTest
